import React from 'react';
import { Box, makeStyles, Skeleton } from 'housecall-ui';
import { HCPTheme } from 'housecall-ui/dist/Theme/Theme';

const useStyles = makeStyles((theme: HCPTheme) => ({
  skeleton: {
    marginTop: theme.spacing(3),
  },
}));

export const ListSkeleton = () => {
  const { skeleton } = useStyles();
  return (
    <Box my={2} data-testid="ListSkeleton__container">
      {[0, 1].map((key) => (
        <Box key={key} mt={2}>
          <Skeleton
            className={skeleton}
            variant="rect"
            height={24}
            aria-label="Loading"
            role="status"
            aria-live="polite"
          />
          <Skeleton
            className={skeleton}
            variant="rect"
            height={85}
            aria-label="Loading"
            role="status"
            aria-live="polite"
          />
        </Box>
      ))}
    </Box>
  );
};
